import { Card, CardGrid, Loader, Pagination } from 'components';
import React, { FC } from 'react';
import {
  ArrowLink,
  ExternalLink,
  Results,
  ResultsHeader,
  ResultsTitle,
} from '../../styles';
import connect from './connect';
import { Props } from './types';

const Blogs: FC<Props> = ({
  available,
  count,
  isDetail,
  items,
  loading,
  location: { search },
  match: { url },
  page,
  pageCount,
  setPage,
  ...rest
}) => {
  if (!available && !loading) {
    return null;
  }

  return (
    <Results {...rest}>
      <ResultsHeader>
        <ResultsTitle>blog {loading ? '' : `(${count})`}</ResultsTitle>
        {!isDetail && (
          <ArrowLink
            text="See all the results: blog"
            to={{
              search,
              pathname: `${url}/blog`,
            }}
          />
        )}
      </ResultsHeader>
      {loading ? (
        <Loader />
      ) : (
        <>
          <CardGrid>
            {items.map(({ id, image, title, link }) => (
              <ExternalLink href={link} key={id} rel="noopener" target="_blank">
                <Card
                  authorType="default"
                  statuses={[]}
                  tags={[]}
                  thumbnail={{
                    file: image || '',
                    mediaType: 'IMAGE',
                    thumbnail: image || undefined,
                  }}
                  title={title}
                />
              </ExternalLink>
            ))}
          </CardGrid>
          <Pagination
            current={Math.min(page, pageCount)}
            setPage={setPage}
            total={pageCount}
          />
        </>
      )}
    </Results>
  );
};

export default connect(Blogs);
